import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";
import {
	GET_ELECTRIC_FAIL_RESULT,
	GET_ELECTRIC_FAIL_RESULT_ERROR,
	GET_ELECTRIC_FAIL_RESULT_SUCCESS,
	GET_ELECTRIC_FAIL_CHART,
	GET_ELECTRIC_FAIL_CHART_ERROR,
	GET_ELECTRIC_FAIL_CHART_SUCCESS,
	RESET_ELECTRIC_FAIL_RESULT,
} from "./ElectricFailActionTypes";

import FetchStatus from "@/constants/fetch-status/FetchStatus";

const mutations = {
	[GET_ELECTRIC_FAIL_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_ELECTRIC_FAIL_RESULT_SUCCESS]: (state, resp) =>
	{
		state.signalSettingIds = resp.signalSettingIds;
		state.operatingRange = resp.operatingRange;
		state.status = FetchStatus.Loaded;
	},
	[GET_ELECTRIC_FAIL_RESULT_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
	[RESET_ELECTRIC_FAIL_RESULT]: (state) =>
	{
		state.status = FetchStatus.Init;
		state.operatingRange = DiagnosticRange.undefined;
	},
	[GET_ELECTRIC_FAIL_CHART]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_ELECTRIC_FAIL_CHART_SUCCESS]: (state, resp) =>
	{
		state.rawOrderChartData = resp.rawOrderChartData;
		state.rawFrequencyChartData = resp.rawFrequencyChartData;
		state.envelopeOrderChartData = resp.envelopeOrderChartData;
		state.envelopeFrequencyChartData = resp.envelopeFrequencyChartData;
		state.orderLayout = resp.orderLayout;
		state.frequencyLayout = resp.frequencyLayout;
		state.status = FetchStatus.Loaded;
	},
	[GET_ELECTRIC_FAIL_CHART_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
};

export default { mutations };
